<template>
    <div class="container">
        <b-modal
            :model-value="showEdiAjustDest"
            :no-close-on-backdrop="true"
            hide-footer
                        centered
            size="lg"
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog edit-ajuste-dest-dialog"
         @hide="closeModal">
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <!-- Campos de búsqueda (solo para adición) -->
                <div v-if="infoEdit?.cuenta == null" class="search-fields">
                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.criterio }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <div class="criterio-inputs-wrapper">
                                <b-form-input 
                                    v-model="critCuenta" 
                                    :placeholder="labels.criterioCuenta" 
                                    @input="buscaCuenta"
                                    class="form-input mb-2"
                                    style="height: 34px; font-size: 13px;"
                                />
                                <b-form-input 
                                    v-model="critDescripcion" 
                                    :placeholder="labels.criterioDescripcion" 
                                    @input="buscaDescripcion"
                                    class="form-input"
                                    style="height: 34px; font-size: 13px;"
                                />
                            </div>
                        </b-col>
                    </b-row>
                </div>

                <!-- Campo de cuenta (modo edición) -->
                <b-row v-if="infoEdit?.cuenta" class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.cuenta }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <div class="display-value">
                            {{ infoEdit?.cuenta }}
                        </div>
                    </b-col>
                </b-row>

                <!-- Campo de descripción (modo edición) -->
                <b-row v-if="infoEdit?.cuenta" class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.description }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <div class="display-value">
                            {{ infoEdit?.descripcion }}
                        </div>
                    </b-col>
                </b-row>

                <!-- Selección múltiple de cuentas (modo adición) -->
                <div v-if="infoEdit?.cuenta == null" class="accounts-section mt-2">
                    <div v-if="localListCuentasSelMul?.length > 0" class="accounts-list mt-1">
                        <div class="select-all-container mb-2">
                            <b-button 
                                size="sm"
                                style="background-color: #2e507a; border-color: #2e507a; font-size: 13px; padding: 4px 16px; border-radius: 4px; color: white;"
                                @click="toggleSelectAllDest"
                            >
                                {{ selectAllDest ? labels.deselectAll : labels.selectAll }}
                            </b-button>
                            <span class="ml-2 text-muted" style="font-size: 13px;">
                                {{ labels.seleccionadas }}: {{ listadoCuentasDest?.length || 0 }}
                            </span>
                        </div>

                        <div class="custom-scroll-table" style="min-height: 180px; height: auto; max-height: 180px; overflow-y: auto;">
                            <table class="table table-sm table-hover" style="font-size: 13px; margin-bottom: 0;">
                                <thead style="position: sticky; top: 0; background: #f8f9fa; z-index: 1;">
                                    <tr>
                                        <th style="width: 100px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">{{ labels.cuenta }}</th>
                                        <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">{{ labels.description }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr 
                                        v-for="(cuenta, idx) in localListCuentasSelMul" 
                                        :key="idx + '-' + cuenta.id"
                                        @click="toggleAccountSelection(cuenta)"
                                        :class="{'table-active-blue': cuenta._selected}"
                                        style="cursor: pointer; border-radius: 8px;"
                                    >
                                        <td style="padding: 5px 8px; border-radius: 8px 0 0 8px;"><strong>{{ cuenta?.cuenta }}</strong></td>
                                        <td style="padding: 5px 8px; border-radius: 0 8px 8px 0;" :title="cuenta.descripcion">{{ cuenta?.descripcion }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div v-else-if="!loadingCuentas" class="text-center py-2" style="height: 180px; display: flex; align-items: center; justify-content: center;">
                        <span class="text-muted" style="font-size: 13px;">{{ labels.noAccountsFound }}</span>
                    </div>

                    <div v-else class="text-center py-2" style="height: 180px; display: flex; align-items: center; justify-content: center;">
                        <b-spinner small class="mr-1"></b-spinner>
                        <span style="font-size: 13px;">{{ labels.loading }}</span>
                    </div>
                </div>

                <!-- Campos de valor (modo edición) -->
                <template v-if="infoEdit?.cuenta">
                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.valor }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-input 
                                v-model="infoEdit.valor" 
                                type="number" 
                                step="0.01"
                                class="form-input"
                                style="height: 36px; font-size: 14px;"
                                @input="onChange"
                            />
                        </b-col>
                    </b-row>

                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.funcional }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-input 
                                v-model="infoEdit.funcional" 
                                type="number" 
                                step="0.01"
                                class="form-input"
                                style="height: 36px; font-size: 14px;"
                                @input="onChange"
                            />
                        </b-col>
                    </b-row>

                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.alterna }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-input 
                                v-model="infoEdit.alterna" 
                                type="number" 
                                step="0.01"
                                class="form-input"
                                style="height: 36px; font-size: 14px;"
                                @input="onChange"
                            />
                        </b-col>
                    </b-row>
                </template>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="mr-2 reset-btn-secondary" @click="closeModal" :disabled="isSaving" style="font-size: 14px; padding: 6px 24px;">
                        {{ labels.close }}
                    </b-button>
                    <b-button class="reset-btn-primary" @click="confirmSave" :disabled="!hasUnsavedChanges || isSaving" style="font-size: 14px; padding: 6px 24px;">
                        <b-spinner v-if="isSaving" small class="mr-1"></b-spinner>
                        {{ isSaving ? labels.saving : labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>

        <!-- Modal de Confirmación -->
        <b-modal
            :model-value="showConfirmModal"
            :no-close-on-backdrop="true"
            hide-footer
                        centered
            size="md"
            :title="confirmLabels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog confirm-dialog"
         @hide="closeConfirmModal">
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ confirmLabels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ confirmLabels.infoText }}</div>
                </div>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="closeConfirmModal" style="font-size: 14px; padding: 6px 24px;">
                        {{ confirmLabels.cancel }}
                    </b-button>
                    <b-button class="reset-btn-primary ml-2" @click="executeAction" style="font-size: 14px; padding: 6px 24px;">
                        {{ confirmLabels.confirm }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import AjustesConsol from '../../services/AjustesConsol'

export default {
    name: "EditAjustesDest",
    props: {
        showEdiAjustDest: {
            type: Boolean,
            default: false
        },
        infoEdit: {
            type: Object,
            default: () => ({})
        },
        listCuentas: {
            type: Array,
            default: () => []
        },
        listCuentasSelMul: {
            type: Array,
            default: () => []
        },
        codReporte: {
            type: [String, Number],
            default: null
        },
        idCompania: {
            type: [String, Number],
            default: null
        },
        vigencia: {
            type: [String, Number],
            default: null
        },
        secuencia: {
            type: [String, Number],
            default: null
        },
        tipo: {
            type: [String, Number],
            default: null
        },
        tipo_ajuste: {
            type: [String, Number],
            default: null
        }
    },
    data: () => ({
        critCuenta: "",
        critDescripcion: "",
        listadoCuentasDest: [],
        selectAllDest: false,
        isSaving: false,
        localListCuentasSelMul: [],
        originalInfoEdit: null,
        showConfirmModal: false,
        pendingAction: null,
        pendingClose: false,
        loadingCuentas: false
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Editar ajuste de destino",
                    save: "Guardar",
                    saving: "Guardando...",
                    close: "Cerrar",
                    criterio: "Criterio de búsqueda",
                    criterioCuenta: "Buscar por cuenta...",
                    criterioDescripcion: "Buscar por descripción...",
                    cuenta: "Cuenta",
                    description: "Descripción",
                    valor: "Valor",
                    funcional: "Funcional",
                    alterna: "Alterna",
                    seleccionadas: "Cuentas seleccionadas",
                    selectAll: "Seleccionar todas",
                    deselectAll: "Deseleccionar todas",
                    noAccountsFound: "No se encontraron cuentas",
                    infoTitle: "Datos del ajuste",
                    infoText: "Actualiza la información del ajuste de destino y guarda los cambios.",
                    loading: "Cargando cuentas..."
                }
            } else {
                return {
                    title: "Edit destination setting",
                    save: "Save",
                    saving: "Saving...",
                    close: "Close",
                    criterio: "Search criteria",
                    criterioCuenta: "Search by account...",
                    criterioDescripcion: "Search by description...",
                    cuenta: "Account",
                    description: "Description",
                    valor: "Value",
                    funcional: "Functional",
                    alterna: "Alternate",
                    seleccionadas: "Selected accounts",
                    selectAll: "Select all",
                    deselectAll: "Deselect all",
                    noAccountsFound: "No accounts found",
                    infoTitle: "Adjustment data",
                    infoText: "Update the destination adjustment information and save changes.",
                    loading: "Loading accounts..."
                }
            }
        },
        confirmLabels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Confirmar acción",
                    infoTitle: "¿Está seguro?",
                    infoText: "¿Está seguro que desea realizar esta acción?",
                    confirm: "Confirmar",
                    cancel: "Cancelar"
                }
            } else {
                return {
                    title: "Confirm action",
                    infoTitle: "Are you sure?",
                    infoText: "Are you sure you want to perform this action?",
                    confirm: "Confirm",
                    cancel: "Cancel"
                }
            }
        },
        hasUnsavedChanges() {
            if (!this.originalInfoEdit || this.isSaving) return false

            if (this.infoEdit?.cuenta) {
                // Modo edición - comparar valores de campos (excluyendo descripción que es solo lectura)
                const currentItem = {
                    valor: this.infoEdit.valor,
                    funcional: this.infoEdit.funcional,
                    alterna: this.infoEdit.alterna
                }
                const originalItem = {
                    valor: this.originalInfoEdit.valor,
                    funcional: this.originalInfoEdit.funcional,
                    alterna: this.originalInfoEdit.alterna
                }
                return JSON.stringify(currentItem) !== JSON.stringify(originalItem)
            } else {
                // Modo adición - comparar lista de cuentas seleccionadas
                const currentList = [...this.listadoCuentasDest].sort()
                const originalList = [...this.originalInfoEdit?.listadoCuentasDest || []].sort()
                return JSON.stringify(currentList) !== JSON.stringify(originalList)
            }
        }
    },
    watch: {
        listCuentasSelMul: {
            immediate: true,
            handler(newVal) {
                this.localListCuentasSelMul = newVal ? [...newVal] : []
                this.initSelectionState()
                this.loadingCuentas = false
            }
        },
        listCuentas: {
            immediate: true,
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    this.localListCuentasSelMul = [...newVal]
                    this.initSelectionState()
                    this.loadingCuentas = false
                }
            }
        },
        showEdiAjustDest: {
            handler(newVal) {
                if (newVal && this.infoEdit && Object.keys(this.infoEdit).length > 0) {
                    // Crear una copia profunda del objeto original para detectar cambios
                    this.originalInfoEdit = JSON.parse(JSON.stringify(this.infoEdit))
                    if (!this.originalInfoEdit?.listadoCuentasDest) {
                        this.originalInfoEdit.listadoCuentasDest = [...this.listadoCuentasDest]
                    }
                    this.isSaving = false
                    this.pendingAction = null
                    this.pendingClose = false
                    this.loadingCuentas = false
                    this.initSelectionState()
                }
            },
            immediate: true
        }
    },
    methods: {
        toggleAccountSelection(cuenta) {
            cuenta._selected = !cuenta._selected
            this.onAccountChange(cuenta)
        },

        buscaCuenta() {
            let filtradas = []
            if (this.critCuenta.length == 0) {
                filtradas = [...this.listCuentas]
            } else {
                const criterio = "^" + this.critCuenta
                filtradas = this.listCuentas.filter(
                    (cuenta) => cuenta.cuenta && cuenta.cuenta.match(criterio)
                )
            }
            this.syncFilteredSelection(filtradas)
        },

        buscaDescripcion() {
            let filtradas = []
            if (this.critDescripcion.length == 0) {
                filtradas = [...this.listCuentas]
            } else {
                filtradas = this.listCuentas.filter(
                    (cuenta) => cuenta.descripcion && cuenta.descripcion.toUpperCase().indexOf(this.critDescripcion.toUpperCase()) >= 0
                )
            }
            this.syncFilteredSelection(filtradas)
        },

        initSelectionState() {
            if (!Array.isArray(this.localListCuentasSelMul) || this.localListCuentasSelMul.length === 0) {
                return
            }

            if (this.listadoCuentasDest.length === 0 && this.infoEdit?.cuenta) {
                this.listadoCuentasDest = [this.infoEdit.cuenta]
            }

            this.localListCuentasSelMul.forEach(cuenta => {
                cuenta._selected = this.listadoCuentasDest.includes(cuenta.cuenta)
            })
            this.updateSelectAll()
        },

        syncFilteredSelection(cuentas) {
            this.localListCuentasSelMul = (cuentas || []).map(cuenta => {
                cuenta._selected = this.listadoCuentasDest.includes(cuenta.cuenta)
                return cuenta
            })
            this.updateSelectAll()
        },

        toggleSelectAllDest() {
            this.selectAllDest = !this.selectAllDest
            this.localListCuentasSelMul.forEach(cuenta => {
                cuenta._selected = this.selectAllDest
                if (this.selectAllDest && !this.listadoCuentasDest.includes(cuenta.cuenta)) {
                    this.listadoCuentasDest.push(cuenta.cuenta)
                } else if (!this.selectAllDest) {
                    const index = this.listadoCuentasDest.indexOf(cuenta.cuenta)
                    if (index > -1) {
                        this.listadoCuentasDest.splice(index, 1)
                    }
                }
            })
            this.onChange()
        },

        onAccountChange(cuenta) {
            if (cuenta._selected && !this.listadoCuentasDest.includes(cuenta.cuenta)) {
                this.listadoCuentasDest.push(cuenta.cuenta)
            } else if (!cuenta._selected) {
                const index = this.listadoCuentasDest.indexOf(cuenta.cuenta)
                if (index > -1) {
                    this.listadoCuentasDest.splice(index, 1)
                }
            }
            this.updateSelectAll()
            this.onChange()
        },

        updateSelectAll() {
            if (!this.localListCuentasSelMul || this.localListCuentasSelMul.length === 0) {
                this.selectAllDest = false
                return
            }
            this.selectAllDest = this.localListCuentasSelMul.every(cuenta => cuenta._selected)
        },

        onChange() {
            // Este método se ejecuta cuando hay cambios
        },

        closeModal() {
            if (this.isSaving) return
            if (this.hasUnsavedChanges) {
                this.pendingAction = 'close'
                this.pendingClose = true
                this.showConfirmModal = true
            } else {
                this.clicked()
            }
        },

        confirmSave() {
            if (this.infoEdit?.cuenta) {
                // Validaciones para edición
                if (this.infoEdit.valor !== null && (this.infoEdit.funcional === null || this.infoEdit.alterna === null)) {
                    this.$toast.error("Funcional y Alterna no pueden ser nulos")
                    return
                }
                if (this.infoEdit.valor === null && (this.infoEdit.funcional !== null || this.infoEdit.alterna !== null)) {
                    this.$toast.error("Funcional y Alterna deben ser nulos")
                    return
                }
            } else {
                // Validación para adición
                if (this.listadoCuentasDest.length === 0) {
                    this.$toast.error("Seleccione al menos una cuenta")
                    return
                }
            }
            this.pendingAction = 'save'
            this.pendingClose = false
            this.showConfirmModal = true
        },

        closeConfirmModal() {
            this.showConfirmModal = false
            this.pendingAction = null
            this.pendingClose = false
        },

        executeAction() {
            this.showConfirmModal = false
            const action = this.pendingAction
            this.pendingAction = null

            if (action === 'save') {
                this.guardaAjuste()
            } else if (action === 'close') {
                this.restoreOriginalValues()
                this.clicked()
            }
        },

        clicked() {
            this.critCuenta = ""
            this.critDescripcion = ""
            this.listadoCuentasDest = []
            this.selectAllDest = false
            this.localListCuentasSelMul = []
            this.pendingAction = null
            this.pendingClose = false
            this.loadingCuentas = false
            this.$emit('closeModal', false)
        },

        reloadTbl() {
            let form = {
                'id': this.secuencia,
                'vigencia': this.vigencia,
                'companyId': this.idCompania
            }
            this.$emit('reloadTblDest', form)
        },
        

        restoreOriginalValues() {
            if (this.originalInfoEdit) {
                // Restaurar solo los campos editables (valor, funcional, alterna)
                // La descripción se mantiene igual
                this.infoEdit.valor = this.originalInfoEdit.valor
                this.infoEdit.funcional = this.originalInfoEdit.funcional
                this.infoEdit.alterna = this.originalInfoEdit.alterna
                
                if (!this.infoEdit?.cuenta) {
                    this.listadoCuentasDest = [...this.originalInfoEdit.listadoCuentasDest || []]
                    this.initSelectionState()
                }
            }
        },

        guardaAjuste() {
            if (this.isSaving) return

            let form = {}
            if (this.infoEdit.cuenta) {
                form = {
                    'id': this.infoEdit.id,
                    'cuenta': this.infoEdit.cuenta,
                    'vigencia': this.infoEdit.vigencia,
                    'companyId': this.infoEdit.id_compania,
                    'valor': this.infoEdit.valor || null,
                    'funcional': this.infoEdit.funcional || null,
                    'alterna': this.infoEdit.alterna || null,
                    'secuencia': this.secuencia,
                    'idUser': this.$store.state.userId,
                }
            } else {
                form = {
                    'vigencia': this.vigencia,
                    'secuencia': this.secuencia,
                    'codReporte': this.codReporte,
                    'companyId': this.idCompania,
                    'tipo': this.tipo,
                    'listadoCuentas': this.listadoCuentasDest,
                    'idUser': this.$store.state.userId,
                }
            }

            this.isSaving = true
            AjustesConsol.updateAjusteDestino(form)
                .then((res) => {
                    if (res.status == 200) {
                        this.$toast.success(res.data.message || "Ajuste guardado correctamente")
                        this.clicked()
                        this.reloadTbl()
                    }
                })
                .catch((error) => {
                    console.log(error)
                    this.$toast.error(error.response?.data?.message || "Error al guardar el ajuste de destino")
                })
                .finally(() => {
                    this.isSaving = false
                })
        }
    }
}
</script>

<style src="../main.css"></style>

<style scoped>
.table-active-blue {
    background-color: #e3f0ff !important;
    border-radius: 8px !important;
}

.table-active-blue td {
    background-color: #e3f0ff !important;
}

.table-responsive .table {
    border-collapse: separate !important;
    border-spacing: 0 4px !important;
}

.table-responsive .table tbody tr {
    border-radius: 8px !important;
    box-shadow: none !important;
}

.table-responsive .table tbody tr td {
    border: none !important;
}

.table-responsive .table tbody tr:hover {
    background-color: #f5f9ff !important;
}

.table-responsive .table tbody tr:hover td {
    background-color: #f5f9ff !important;
}

.table-responsive .table td,
.table-responsive .table th {
    border: none !important;
}

.custom-scroll-table {
    height: 180px;
    min-height: 180px;
    max-height: 180px;
    overflow-y: auto;
    position: relative;
}

.custom-scroll-table::-webkit-scrollbar {
    width: 8px;
}

.custom-scroll-table::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.custom-scroll-table::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
}

.custom-scroll-table::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.criterio-inputs-wrapper {
    width: 100%;
}

.display-value {
    padding: 6px 12px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #e9ecef;
    font-size: 14px;
    color: #495057;
    min-height: 36px;
}
</style>